import { render, staticRenderFns } from "./Pod.vue?vue&type=template&id=edac4166&scoped=true&"
import script from "./Pod.vue?vue&type=script&lang=js&"
export * from "./Pod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edac4166",
  null
  
)

export default component.exports